<template lang="html">
    <div>
        <nav class="sb-topnav navbar navbar-expand navbar-light bg-light-emphasis">
            <!-- Navbar Brand-->
            <router-link :to="{ name: 'Dashboard' }" class="navbar-brand ps-3">
                <img src="../assets/logo-w.png" alt="" width="40">
                Dashboard 5 ส.
            </router-link>
            <!-- Sidebar Toggle-->
            <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" href="#">
                <i class="bi bi-list"></i>
            </button>
        </nav>
        <div id="layoutSidenav">
            <div id="layoutSidenav_nav">
                <nav class="sb-sidenav accordion sb-sidenav-light" id="sidenavAccordion">
                    <div class="sb-sidenav-menu">
                        <div class="nav">
                            <router-link :to="{ name: `${item.path}` }" class="nav-link"
                                v-for="(item, index) in menuItems" :key="index">
                                <div class="sb-nav-link-icon">
                                    <i :class="item.icon"></i>
                                </div>
                                {{ item.name }}
                            </router-link>
                        </div>
                    </div>
                </nav>
            </div>
            <div id="layoutSidenav_content">
                <main class="main">
                    <router-view></router-view>
                </main>
                <footer class="py-4 bg-light mt-auto">
                    <div class="container-fluid px-4">
                        <div class="d-flex align-items-center justify-content-between small">
                            <div class="text-muted">Copyright © 2025 ระบบบันทึกข้อมูล 5 ส. โรงพยาบาลวานรนิวาส | พัฒนาโดย นายบัญชาชัย แพงพิมพ์โล้</div>
                            <div>
                                <!-- <a href="#">Privacy Policy</a>
                                ·
                                <a href="#">Terms &amp; Conditions</a> -->
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<!-- pageFireExtinguisher
pageRoomTemperature
pageMedicineCabinet
pageRestroom -->
<script>
export default {
    data() {
        return {
            menuItems: [
                { path: 'pageMedicineCabinet', name: "อุณหภูมิตู้ยาและเวชภัณฑ์", icon: 'bi bi-thermometer' },
                { path: 'pageRoomTemperature', name: "อุณหภูมิห้อง", icon: 'bi bi-house-door' },
                { path: 'pageFireExtinguisher', name: "ถังดับเพลิง", icon: 'bi bi-shield-shaded' },
                { path: 'pageRestroom', name: "ห้องน้ำ", icon: 'bi bi-people' },
                // { path: 'pageGas', name: "ค่าแรงดันแก๊ส", icon: 'bi bi-clipboard-check' },
            ]
        };
    },
    mounted() {
        // Add event listener for sidebar toggle
        const sidebarToggle = document.body.querySelector('#sidebarToggle');
        if (sidebarToggle) {
            sidebarToggle.addEventListener('click', (event) => {
                event.preventDefault();
                document.body.classList.toggle('sb-sidenav-toggled');
                localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
            });
        }

        // Add event listener for clicks outside the sidebar
        // this.addClickOutsideListener();
    },
    beforeUnmount() {
        // Cleanup event listeners when the component is destroyed
        this.removeClickOutsideListener();
    },
    methods: {
        addClickOutsideListener() {
            // Listen for click events on the document to detect clicks outside the sidebar
            document.addEventListener('click', this.handleClickOutside);
        },
        removeClickOutsideListener() {
            // Remove the event listener when the component is destroyed
            document.removeEventListener('click', this.handleClickOutside);
        },
        handleClickOutside(event) {
            const sidebar = document.getElementById('layoutSidenav_nav');  // Sidebar element
            const sidebarToggle = document.getElementById('sidebarToggle');  // Sidebar toggle button

            // If the click is outside the sidebar and not on the toggle button, hide the sidebar
            if (sidebar && !sidebar.contains(event.target) && !sidebarToggle.contains(event.target)) {
                document.body.classList.add('sb-sidenav-toggled');
                localStorage.setItem('sb|sidebar-toggle', true); // Update localStorage
            }
        }
    },
}
</script>

<style lang="">
import '../assets/styles.css'

</style>
